import { useState } from 'react';
import styles from './M_QRCodeContainer.module.css';
import cn from 'classnames';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { generateCustomQRCode } from '@/utils/qrCodeGenerator';

export default function M_QRCodeContainer() {
  const profileUrl = `${window.location.origin}/profile`;
  const qrCodeDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
    generateCustomQRCode(profileUrl)
  )}`;
  const [isVisible, setIsVisible] = useState(true);

  const handleCopyQRCode = () => {
    navigator.clipboard.writeText(profileUrl);
  };

  const handleCloseQRCode = () => {
    setIsVisible(false);
  };

  return isVisible ? (
    <div className={styles.wrapper}>
      <p className={cn(styles.text, 'text-p-7')}>
        Поделитесь своим профилем через QR-код
      </p>
      <img src={qrCodeDataUrl} alt='QR-код профиля' />
      <div className={styles.buttons_wrapper}>
        <A_Button
          variant='secondary'
          onClick={handleCopyQRCode}
          fontSize='text-p-4'
          size='small'
          width='100%'
        >
          Скопировать
        </A_Button>
        <A_Button
          variant='tertiary'
          onClick={handleCloseQRCode}
          fontSize='text-p-4'
          size='small'
          width='100%'
        >
          Закрыть
        </A_Button>
      </div>
    </div>
  ) : null;
}
